/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DataLoaderType {
    CURRENCY = 'currency',
    SLOTTED_JOB = 'slottedJob',
    COMPANY_JOB = 'companyJob',
    COMPANY_JOB_FAMILY = 'companyJobFamily',
    COMPANY_JOB_PAYMARKET_REWRITE = 'companyJobPaymarketRewrite',
    COMPANY_JOB_LEVEL = 'companyJobLevel',
    COMPANY_JOB_TAG = 'companyJobTag',
    EMPLOYEE_DATA = 'employeeData',
    SALARY_RANGE = 'salaryRange',
    JOB_MAPPING = 'jobMapping',
    MARKET_PRICE = 'marketPrice',
    CUT_REMOVAL = 'cutRemoval',
    PAYMARKET_LIST = 'paymarketList',
    COMPOSITE_COMMENT = 'compositeComment',
    COMPOSITE_TAG = 'compositeTag',
    RANGE_GROUP_ELIGIBILITY = 'rangeGroupEligibility',
    RANGE_ZONE_ELIGIBILITY = 'rangeZoneEligibility',
    RANGE_NAME_ELIGIBILITY = 'rangeNameEligibility',
    CUSTOMER_FILE = 'customerFile',
    SURVEY = 'survey',
    RANGE_ASSIGNMENT = 'rangeAssignment',
    DATA_MODEL_RANGE_ASSIGNMENT = 'dataModelRangeAssignment',
}
